"use client";

import cx from "classnames";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { useMemo, useState } from "react";
const MegaMenu = ({
  menuData
}) => {
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [hoverTimeout, setHoverTimeout] = useState(null);
  const {
    categories,
    categoryLookup
  } = menuData || {
    categories: [],
    categoryLookup: {}
  };
  const t = useTranslations("Common");
  const handleMouseEnter = categoryId => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      setHoverTimeout(null);
    }
    const timeout = setTimeout(() => {
      setHoveredCategory(categoryId);
    }, 200);
    setHoverTimeout(timeout);
  };
  const handleMouseLeave = () => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      setHoverTimeout(null);
    }
    const timeout = setTimeout(() => {
      setHoveredCategory(null);
    }, 300);
    setHoverTimeout(timeout);
  };

  // simple lookup for the current category
  const currentCategory = useMemo(() => hoveredCategory ? categoryLookup[hoveredCategory] : null, [hoveredCategory, categoryLookup]);
  const hasSubcategories = currentCategory?.subcategories?.length > 0;
  if (categories?.length === 0) return null;
  return <div className="border-header-divider relative w-full border-t" onMouseLeave={handleMouseLeave} data-sentry-component="MegaMenu" data-sentry-source-file="MegaMenu.jsx">
      {/* Top navigation */}
      <nav className="mx-auto w-full max-w-screen-xl">
        <div className="flex items-center justify-start gap-6 [scrollbar-width:none] md:gap-10 md:overflow-x-auto md:scroll-smooth lg:overflow-hidden [&::-webkit-scrollbar]:hidden">
          {categories.map(category => {
          if (!category.name) return null;
          return <Link key={category.id} href={`/collections/${category.slug}`} className={cx("text-menu-text hover:text-menu-mainMenuItemActive group relative shrink-0 px-2 py-5 text-sm font-medium md:text-base", {
            "border-menu-bg border-b-2": hoveredCategory !== category.id,
            "border-menu-bottom-border !text-menu-mainMenuItemActive border-b-2": hoveredCategory === category.id
          })} onMouseEnter={() => handleMouseEnter(category.id)}>
                {category.name}
              </Link>;
        })}
        </div>
      </nav>

      {/* Mega menu dropdown */}
      <section className={cx("bg-menu-spill-bg absolute left-0 top-full z-50 w-full shadow-lg transition-opacity duration-300 ease-in-out", hasSubcategories && hoveredCategory ? "opacity-100" : "pointer-events-none opacity-0")}>
        <div className="mx-auto w-full max-w-screen-xl py-6">
          <div className="snap-y snap-mandatory overflow-y-auto scroll-smooth [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            <div className="flex snap-start flex-wrap gap-x-20 gap-y-10">
              {currentCategory?.subcategories?.map((subcategory, index) => {
              if (!subcategory.name) return null;
              return <div key={subcategory.id} className={cx(
              // Every 5th item (1st, 6th, 11th...) add snap-start for row snapping
              index % 5 === 0 ? "snap-start" : "")}>
                    <Link href={`/collections/${subcategory.slug}`} className="text-menu-subtext hover:text-menu-subtext/80 mb-3 block text-sm font-semibold transition-all duration-300 ease-in-out hover:underline hover:[text-underline-offset:2px] md:text-base">
                      {subcategory.name}
                    </Link>
                    <div className="flex flex-col flex-wrap content-start gap-x-8">
                      {subcategory?.subcategories?.slice(0, 10).map(subSubcategory => {
                    if (!subSubcategory.name) return null;
                    return <Link key={subSubcategory?.id} href={`/collections/${subSubcategory?.slug}`} className="text-menu-spill-text hover:text-menu-active block max-w-64 py-[0.5px] text-base transition-all duration-300 ease-in-out hover:underline hover:[text-underline-offset:2px]">
                              {subSubcategory?.name}
                            </Link>;
                  })}
                    </div>
                    {/* view all link */}
                    {subcategory?.subcategories?.length > 10 && <Link href={`/collections/${subcategory.slug}`} className="text-anchor-text hover:text-anchor-hover mb-3 block py-1 text-sm font-semibold transition-all duration-300 ease-in-out hover:underline hover:[text-underline-offset:2px] md:text-base">
                        {t("View_All")}
                      </Link>}
                  </div>;
            }) || []}
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default MegaMenu;